import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import definitiveStore from "./reducers/store";
import { Provider } from "react-redux";
import { IntlProvider } from "react-intl";
import { getMessagesFromLocale } from "./i18n";
import packageJson from "../package.json";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fal } from "@fortawesome/pro-light-svg-icons";

library.add(fal, far, fas);

const messages = getMessagesFromLocale("it");

console.log("BUSINESS INFORMATION APP - version:", packageJson.version);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={definitiveStore.store}>
            <IntlProvider messages={messages} locale="it" defaultLocale="en">
                <App />
            </IntlProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root"),
);

reportWebVitals();
